export const LocalStorageKeys = {
  LpcActiveSession: "LpcActiveSession",
  DeepLink: "DeepLink",
};
